export default function FooterBanner() {
  return (
    <div className="w-full bg-[#0d0d1a] border-t border-[#e8b800]/10 py-6 flex items-center justify-center px-4">
      <img
        src="https://xt30sf.b-cdn.net/media/b5ab9745ca896588eaadc.jpg"
        alt="MrBoom9"
        className="max-w-4xl w-full h-auto object-contain rounded-lg opacity-80"
      />
    </div>
  );
}
